<template>
  <label class="styled-checkbox" :class="{ checked: !!modelValue }">
    <input type="checkbox" v-model="internalValue" />
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const internalValue = computed({
  get: () => props.modelValue,
  set: (newValue: boolean) => {
    emit("update:modelValue", newValue);
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

@checkbox-width: 1.8em;
@checkbox-height: 1em;
@checkbox-inner-margin: @checkbox-height * 0.05;
@checkbox-inner-height: @checkbox-height - 2 * @checkbox-inner-margin;
@checkbox-inner-width: @checkbox-inner-height;
@checkbox-unchecked-color: @toggle-unchecked;
@checkbox-checked-color: @brand-primary;
// @checkbox-hover-color: fade(darken(@bright-pink, 15%), 70%);

.styled-checkbox {
  input[type="checkbox"] {
    visibility: hidden;
    width: 0;
    height: 0;
    margin: 0;
  }

  display: inline-block;
  position: relative;
  width: @checkbox-width;
  height: @checkbox-height;
  cursor: pointer;

  &::before,
  &::after {
    transition: background-color 0.3s, left 0.3s;
  }

  &::before {
    visibility: visible;
    content: "";
    display: inline-block;
    height: @checkbox-height;
    width: @checkbox-width;
    background-color: @checkbox-unchecked-color;
    border-radius: @checkbox-height * 0.5;
    box-shadow: inset 0 0 0.1em rgba(0, 0, 0, 0.3);
  }

  &::after {
    visibility: visible;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: @checkbox-inner-width;
    height: @checkbox-inner-height;
    background-color: white;
    border-radius: @checkbox-height * 0.5;
    margin: @checkbox-inner-margin;
    box-sizing: border-box;
    border-left: 1px solid #9e9e9e;
    border-bottom: 1px solid #9e9e9e;
    filter: drop-shadow(-0.1em 0 0.05em rgba(0, 0, 0, 0.2));
  }

  &.checked {
    &::before {
      background-color: @checkbox-checked-color;
    }

    &::after {
      left: calc(@checkbox-width - @checkbox-inner-width - 2 * @checkbox-inner-margin - 1px);
    }
  }
}
</style>
